import React, { useEffect, useState, useRef } from 'react';
import styled from "styled-components";

/* Search.tsx는 검색창을 보여주고 검색어를 입력받는 컴포넌트 */

interface SearchProps {
    searchedTerm: string;
    onSearchedTerm: React.Dispatch<React.SetStateAction<string>>;
    styleFor: string;
    placeholder: string;
}

const Body = styled.div<{$styleFor: string}>`
    display: flex;
    align-items: center;
    position: ${({$styleFor}) => 
        $styleFor === process.env.REACT_APP_STYLE_HOME_SEARCH ? 'absolute' : 'relative'};
    left: ${({$styleFor}) => 
        $styleFor === process.env.REACT_APP_STYLE_HOME_SEARCH ? '50%' : 'auto'};
    transform: ${({$styleFor}) => 
        $styleFor === process.env.REACT_APP_STYLE_HOME_SEARCH ? 'translateX(-50%)' : 'none'};
    width: ${({$styleFor}) => 
        $styleFor === process.env.REACT_APP_STYLE_HOME_SEARCH ? '300px' : '100%'};
`;

const SearchBox = styled.input`
    width: 100%;
    max-width: 300px;
    height: 2.5rem;

    margin: 0 auto;
    padding: 0 1rem;
    padding-right: 3rem;

    border-radius: 2rem;
    border: 1px solid ${props => props.theme.SEARCH.BORDER};
    background: ${props => props.theme.SEARCH.BACKGROUND};
    font-size: 0.95rem;
    transition: all 0.3s ease;
    box-shadow: inset 0 2px 4px ${props => props.theme.SEARCH.SHADOW};
    color: ${props => props.theme.CONTENT.TITLE_COLOR};

    &:focus {
        outline: none;
        width: 110%;
        border-color: ${props => props.theme.SEARCH.FOCUS.BORDER};
        box-shadow: 0 0 0 2px ${props => props.theme.SEARCH.FOCUS.SHADOW};
    }

    &::placeholder {
        color: ${props => props.theme.CONTENT.TITLE_COLOR};
    }
`;

function Search({searchedTerm, onSearchedTerm, styleFor, placeholder}: SearchProps) {
    const [searchTerm, setSearchTerm] = useState(searchedTerm || "");

    // 한글 조합 중인지 체크하는 flag
    const isComposing = useRef(false);

    const onCompositionStart = () => {
            isComposing.current = true;
    }

    const onCompositionEnd = (e:React.CompositionEvent<HTMLInputElement>) => {
            isComposing.current = false;

            // 조합 끝난 최종 결과를 상태에 반
            setSearchTerm(e.currentTarget.value);
    }

    const onChange = (e:React.ChangeEvent<HTMLInputElement>) => {
        setSearchTerm(e.target.value);
    };

    useEffect(() => {
        onSearchedTerm(searchTerm); // props는 읽기 전용이므로 반드시 이렇게 콜백 함수를 통해 부모 컴포넌트로 전달해야함
    }, [searchTerm]);

    return <Body $styleFor={styleFor}>
        <SearchBox
                value={searchTerm }
                onChange={onChange}
                onCompositionStart={onCompositionStart}
                onCompositionEnd={onCompositionEnd}
                placeholder={placeholder}
        />
    </Body>;
}

export default Search;
